export default {
  STORAGE: process.env.REACT_APP_STORAGE_BASE_URL,
} as const;
